module.exports = __webpack_public_path__ + "static/img/xcx_img.b62d9db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/new/index/xcx_img.jpg
// module id = RB8u
// module chunks = 24